// extracted by mini-css-extract-plugin
export default {"container":"BacklogPage_container__SMbaX","header":"BacklogPage_header__bLle3","scrollContainer":"BacklogPage_scrollContainer__J7FdZ"};